import { render, staticRenderFns } from "./SelectSubjects.vue?vue&type=template&id=d14bf988"
import script from "./SelectSubjects.vue?vue&type=script&lang=js"
export * from "./SelectSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports